import { ErrorParser } from '@i22team/rocket';
import forOwn from 'lodash-es/forOwn';
import isPlainObject from 'lodash-es/isPlainObject';

import ERROR_MESSAGES from '~/assets/01-settings/js/errors.json';

const errorParser = new ErrorParser(ERROR_MESSAGES);
export default errorParser;

export type ErrorData = Record<string, Record<'error', string>[]>;

export const getErrorMessage = (
  data: ErrorData | unknown,
  customFallbackMessage: string | undefined
) => {
  const response = errorParser.getMessagesFlatten(data, customFallbackMessage);
  return response.length > 0 ? response[0] : undefined;
};

/** @deprecated use "errorParser" from default export instead */
export function getErrorMessages(
  data: unknown,
  customFallbackMessage: string | undefined = undefined,
  errorMessages = ERROR_MESSAGES
) {
  const customErrorParser = new ErrorParser(errorMessages);
  const parsedMessages = customErrorParser.getMessagesSimplified(
    data,
    customFallbackMessage || ERROR_MESSAGES.unknown || 'Ein unbekannter Fehler ist aufgetreten.'
  );
  return customErrorParser.unpackPath(parsedMessages);
}

type RawMessage = {
  error: string | undefined;
};
export function parseErrorsRecursive(errorData: unknown, messages: string[] = []) {
  forOwn(errorData, (fieldErrorData: RawMessage | RawMessage[]) => {
    if (Array.isArray(fieldErrorData)) {
      fieldErrorData.forEach((data) => {
        if (!data?.error) return;
        messages.push(data.error);
      });
      return;
    }
    if (isPlainObject(fieldErrorData)) {
      parseErrorsRecursive(fieldErrorData, messages);
      return;
    }
    if (typeof fieldErrorData === 'string') {
      messages.push(fieldErrorData);
    }
  });

  return messages;
}
